import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import TgDatasetTrainingGuide from "../components/TgDatasetTrainingGuide/TgDatasetTrainingGuide";
import styles from "./NewCreateTgModelDataset.module.scss";
import NewTgDatasetEditor from "./NewTgDatasetEditor/NewTgDatasetEditor";

type Props = {
	onContinue: () => void;
};

const NewCreateTgModelDataset = ({ onContinue }: Props) => {
	return (
		<Box className={styles.container}>
			<Box className={styles.leftPane}>
				<NewTgDatasetEditor onContinue={onContinue} />
			</Box>
			<Box className={styles.rightPane}>
				<TgDatasetTrainingGuide baseTileWidth={126} baseTileHeight={107} />
			</Box>
		</Box>
	);
};

export default observer(NewCreateTgModelDataset);
